export const kcl = {
  agencyCode: '003580',
  name: 'Kilgore College',
  shortName: 'KCL',
  slug: 'kcl',
};
